import { Check, CircleX } from 'components/icons'
import React from 'react'
import styled from 'styled-components'
import { LBCPoints } from './components'
import { useTranslation } from 'react-i18next'
import { formatNumber } from 'utils/numbers'
import Tooltip from 'components/Tooltip'
import { makeStyles } from '@material-ui/core'

const Container = styled('article')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
  padding: '15px 10px',
  borderBottom: '1px solid #DFDFDF',
}))

const ProjectName = styled('h1')(({ theme }) => ({
  textTransform: 'uppercase',
  fontSize: 15,
  color: '#0F3444',
  fontWeight: 400,
  margin: 0,
}))

const RegionContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  flexWrap: 'wrap',
  fontSize: 15,
  color: '#6f7f88',
  gap: 4,
}))

const ValuesContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  fontSize: 14,
  color: '#919191',
  gap: 8,
  justifyContent: 'space-between',
}))

const ValueItem = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
}))

const ValueLabel = styled('span')(({ theme }) => ({
  fontWeight: 'bold',
}))

const TooltipSubject = styled('span')(({ theme }) => ({
  fontWeight: 'bolder',
}))

const useStyledTooltip = makeStyles(theme => ({
  arrow: {
    color: 'rgb(255,60,60)',
  },
  tooltip: {
    padding: theme.spacing(1, 2),
    backgroundColor: 'rgb(255,60,60)',
    borderRadius: 8,
    color: theme.palette.white.main,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'normal',
  },
}))

export const Project = ({ project }) => {
  const { t, i18n } = useTranslation()
  const classes = useStyledTooltip()

  const displayMaker = () => {
    if (project.ecorregiao === 'Inválida' || project.dbpSaldo < 0) return <CircleX />
    if (project.lbc > 0) return <Check />
    return null
  }

  const getTooltipMessage = () => {
    const messageList = []

    if (project.ecorregiao === 'Inválida')
      messageList.push({
        subject: t('creditosDeBiodiversidade.ecorregioao'),
        msg: t('creditosDeBiodiversidade.ecorregiaoErroMsg'),
      })

    if (project.dbpSaldo < 0)
      messageList.push({
        subject: t('creditosDeBiodiversidade.pontuacaoUtilizada'),
        msg: t('creditosDeBiodiversidade.saldoDPBErroMsg'),
      })

    if (project.passivelLbc === false)
      messageList.push({
        subject: 'LBC',
        msg: t('creditosDeBiodiversidade.LBCErroMsg'),
      })

    if (messageList.length) {
      return (
        <div>
          {messageList.map(message => (
            <p>
              <TooltipSubject>{message.subject}: </TooltipSubject>
              {message.msg}
            </p>
          ))}
        </div>
      )
    }

    return ''
  }

  return (
    <Tooltip title={getTooltipMessage()} classes={classes}>
      <Container>
        <ProjectName>{project.nome}</ProjectName>
        <RegionContainer>
          <span>{t('creditosDeBiodiversidade.ecorregioao')}:</span>
          <span>{project.ecorregiao === "Inválida" ? t('creditosDeBiodiversidade.invalida') : project.ecorregiao}</span>
          {displayMaker()}
        </RegionContainer>

        <ValuesContainer>
          <ValueItem>
            <ValueLabel>{t('creditosDeBiodiversidade.totalDPB')}</ValueLabel>
            <span>{formatNumber(project.dbpTotal, i18n.language)}</span>
          </ValueItem>

          <ValueItem>
            <ValueLabel>{t('creditosDeBiodiversidade.saldoDPB')}</ValueLabel>
            <span>{formatNumber(project.dbpSaldo, i18n.language)}</span>
          </ValueItem>
        </ValuesContainer>

        <ValuesContainer>
          <ValueItem>
            <LBCPoints value={project.lbc} />
          </ValueItem>
        </ValuesContainer>
      </Container>
    </Tooltip>
  )
}
